import { render, staticRenderFns } from "./DragDiv.vue?vue&type=template&id=63f7956b&"
import script from "./DragDiv.vue?vue&type=script&lang=js&"
export * from "./DragDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports